import React, { lazy } from 'react';
import { Linkedin } from 'lucide-react';
export function TeamPage() {
  const teamMembers = [{
    name: 'Precious Imuwahen Ogbomo',
    title: 'Founder, Strategic Lead',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fgM76ZqeykjR9P5o8eiPfX/IMG_0273.jpg',
    linkedIn: 'https://www.linkedin.com/in/preciousajoonu/',
    bio: `Precious is a distinguished Learning and Development expert with over 15 years of experience driving strategy execution, organizational development, and large-scale skills transformation across Africa. She led the Jobberman Soft Skills Training Programme, upskilling over 2 million young people across the continent.

She served as Pioneer Director General of the John Odigie-Oyegun Public Service Academy and holds an MSc in Management Innovation & Change (with Distinction) from the University of Aberdeen. Precious is a certified World Bank Development Knowledge Facilitator and member of CIPM.`
  }, {
    name: 'Osaze Ighoretin Ogbomo',
    title: 'Chief Operating Officer (COO) and Legal Adviser',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8Txkd1YDMxJFMykKsH1KR4/Osaze.jpg',
    linkedIn: 'https://www.linkedin.com/in/osaze-ogbomo-ll-b-b-l-llm-82b48945/',
    bio: `Osaze Ogbomo is a seasoned professional with over 11 years of experience in law, governance, and business reforms. He specializes in legal advisory, policy management, procurement, monitoring and evaluation frameworks, and MSME empowerment.

He holds an LLM in International Commercial Law from Brunel University, London, an LLB from KNUST, Ghana, and a Barrister-at-Law (BL) qualification from the Nigerian Law School. He is certified in Business Writing, CCNA, and Project Management (PMP).`
  }, {
    name: 'Paul Omugbe',
    title: 'Chief Financial Officer',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1x9yFWHxtEAPobV3pvsTLH/Paul.jpg',
    linkedIn: 'https://www.linkedin.com/in/detroyx/',
    bio: `Paul brings over 12 years of expertise in strategy, financial management, project management, and business administration. Notable achievements include managing projects for PPPRA, conducting a forensic review for NNPC, and training over 3,000 Edo State civil servants in project management.

Paul is a Fellow of the Institute of Chartered Accountants of Nigeria (ICAN) and a Chartered Professional Accountant (CPA Ontario). He holds a BSc in Applied Accounting from Oxford Brookes University and is a Certified Project Management Professional (PMP).`
  }, {
    name: 'Adeola Andrea Peregrino',
    title: 'Creative Director',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/q3S49Wz9DXAgMp7a2rCgLQ/Adeola.jpg',
    linkedIn: 'https://www.linkedin.com/in/adeola-andrea-peregrino-36b13b112/',
    bio: `Adeola Peregrino is a visionary leader in media and creative consultancy, specializing in frameworks that drive job creation and sectoral growth. She spearheaded Jobberman's Digital Skills course, reaching 1,500 learners with measurable employment outcomes.

A seasoned creative producer, Adeola has led government-commissioned documentaries including The Edo Story for Edo State Government and Leave No One Behind for Lagos State Government. She holds a certification in storytelling from the New York Film Academy.`
  }, {
    name: 'Adesuwa Elizabeth',
    title: 'Chief Technology Officer (CTO)',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/e6LzL4BxudY5v6GQ4RKeKG/Adesuwa.jpg',
    linkedIn: 'https://www.linkedin.com/in/adesuwa-ojo-096173140/',
    bio: `Adesuwa is a seasoned IT professional with over a decade of experience in data engineering, project management, and business operations. She specializes in data migration, system integration, Agile project management, and business process optimization.

Adesuwa holds an MBA from the University of Aberdeen and an MSc in Management Information Systems from the University of Houston-Clear Lake. She is a certified Project Management Professional (PMP), Scrum Master, and holds a Microsoft Azure Data Fundamentals certification.`
  }];
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1612">
      <main className="flex-grow pt-20" data-id="element-1613">
        {/* Hero Section */}
        <section className="relative py-32 overflow-hidden" data-id="element-1614">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-green-50" data-id="element-1615" />
          <div className="absolute top-20 right-10 w-96 h-96 bg-green-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20" data-id="element-1616" />

          <div className="container mx-auto px-6 lg:px-8 relative z-10" data-id="element-1617">
            <div className="max-w-4xl mx-auto text-center" data-id="element-1618">
              <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-gray-900 mb-8" data-id="element-1619">
                Meet the
                <br data-id="element-1620" />
                <span className="bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent" data-id="element-1621">
                  Team
                </span>
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed" data-id="element-1622">
                Led by industry experts with proven track records in leadership,
                culture transformation, and organizational strategy.
              </p>
            </div>
          </div>
        </section>

        {/* Team Members */}
        <section className="py-16 bg-white" data-id="element-1623">
          <div className="container mx-auto px-6 lg:px-8" data-id="element-1624">
            <div className="max-w-6xl mx-auto space-y-24" data-id="element-1625">
              {teamMembers.map((member, index) => <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} gap-12 items-start`} data-id="element-1626">
                  <div className="md:w-1/3" data-id="element-1627">
                    <div className="aspect-square rounded-3xl overflow-hidden shadow-xl border-4 border-white ring-1 ring-gray-100 hover:shadow-2xl transition-shadow duration-300" data-id="element-1628">
                      <img src={member.image} alt={member.name} loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-1629" />
                    </div>
                  </div>
                  <div className="md:w-2/3" data-id="element-1630">
                    <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1631">
                      {member.name}
                    </h2>
                    <p className="text-blue-600 font-medium mb-4 text-lg" data-id="element-1632">
                      {member.title}
                    </p>
                    <a href={member.linkedIn} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 mb-6" data-id="element-1633">
                      <Linkedin className="w-4 h-4" data-id="element-1634" />
                      LinkedIn
                    </a>
                    <div className="text-gray-700 space-y-4 whitespace-pre-line leading-relaxed" data-id="element-1635">
                      {member.bio}
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
      </main>
    </div>;
}